module.exports = __webpack_public_path__ + "static/1142910868.4b1a5548.jpg";